import columns from './utils/columns'
import entry from './utils/entry'
import organization from './utils/organization'
import person from './utils/person'
import project from './utils/project'
import summaries from './utils/summaries'
import user from './utils/user'

const state = () => ({
  columns,
  summaries,

  action: 'read',
  error: false,
  selected: null,
  submitted: null,

  week: [],
  weekdate: null,
  timeShift: 0,
  timeTypes: [],

  clients: [],
  isLoadingClients: false,
  didLoadClientsFail: false,

  entry,
  entries: [],
  defaultEntry: Object.create(entry.defaults),

  manager: null,
  defaultManager: Object.create(person.defaults),
  isLoadingManager: false,
  didLoadManagerFail: false,

  organization,
  organizations: [],
  defaultOrg: Object.create(organization.defaults),

  person: null,
  persons: [],
  defaultPerson: Object.create(person.defaults),

  project,
  projects: [],
  defaultProject: Object.create(project.defaults),

  publisher: null,
  publishers: [],
  isLoadingPublishers: false,
  didLoadPublishersFail: false,

  levels: ['reader', 'writer', 'admin'],
  roles: ['external', 'internal'],
  services: [],

  user: null,
  defaultUser: Object.create(user.defaults),

  isSettingsModalVisible: null,

  isLoadingInternal: false,
  didLoadInternalFail: false,

  isLoadingOverview: false,
  didLoadOverviewFail: false,

  isLoadingOrganization: false,
  didLoadOrganizationFail: false,
  isOrganizationModalVisible: false,

  isLoadingPersons: null,
  didLoadPersonsFail: null,

  isLoadingPerson: null,
  didLoadPersonFail: null,
  isUserFormVisible: null,

  isLoadingProjects: false,
  didLoadProjectsFail: false,

  isLoadingProject: false,
  didLoadProjectFail: false,
  isProjectModalVisible: false,

  isLoadingTime: false,
  didLoadTimeFail: false,
  isTimeModalVisible: false,

  isLoadingTimeType: false,
  didLoadTimeTypeFail: false,
  isTimeTypeDropdownVisible: false,
})

export default state
